import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useCalcPriceQuery } from "../../api/queries/priceQueries";
import { SHOPPING_CART_MODE } from "../../constants";
import { useCartQuery } from "../../hooks/useCart";
import { mappingBookingState2RequestDTO } from "../../mapping/mappingBookingState2RequestDTO";

export const useOrderProduct = () => {
  const { data } = useCartQuery();
  const cartItems: SelectableBooking[] = useMemo(() => data ?? [], [data]);
  const [searchParams] = useSearchParams();
  const mode = (searchParams.get("mode") ?? "").toString();
  const [voucherId, setVoucherId] = useState<number | undefined>(undefined);
  const bookingStates = useMemo(() => data ?? [], [data]);
  const bookingPrice = useCalcPriceQuery(
    bookingStates.map((x) =>
      mappingBookingState2RequestDTO(x, {
        voucherId,
      }),
    ),
    {
      params: {
        updateBookingMode: mode === SHOPPING_CART_MODE.UPDATE_BOOKING,
      },
    },
  );
  return { cartItems, voucherId, setVoucherId, bookingPrice };
};

export type TUseOrderProduct = ReturnType<typeof useOrderProduct>;
